import React from "react";
import { statusLabel, statusTone } from "@/lib/format";

const toneMap = {
    success: "bg-emerald-50 text-emerald-700 border-emerald-200",
    warning: "bg-amber-50 text-amber-700 border-amber-200",
    info: "bg-blue-50 text-blue-700 border-blue-200",
    danger: "bg-red-50 text-red-700 border-red-200",
    muted: "bg-gray-100 text-gray-600 border-gray-200",
};

export const StatusBadge = ({ status, className = "", ...rest }) => {
    const tone = toneMap[statusTone(status)] || toneMap.muted;
    return (
        <span
            className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[11px] font-medium ${tone} ${className}`}
            {...rest}
        >
            <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
            {statusLabel(status)}
        </span>
    );
};

export default StatusBadge;
